import { useRef } from "react";
import { isEmpty, noop } from "lodash";
import NextFlowCard from "./nextFlowCard/NextFlowCard";
import NextFlowModal from "../nextFlowModal/NextFlowModal";
import Observable from "../../../../../../../utils/Observable";

import { AddToLinkButton } from "../../../../../../../components";
import { type FlowEndInfo } from "../../../types";
import { type OnTriggerModalObserver } from "../../../ReactFlowCanvas/nodes/StartOfTheFlow/StartOfTheFlowCardWrapper/StartOfTheFlowCardWrapper";

import styles from "./nextFlow.module.scss";

export interface NextFlowProps {
  isReadOnly: boolean;
  flowEndInfo: FlowEndInfo;
  onFlowEndChange: (flowEndInfo: FlowEndInfo) => void;
}

const NextFlow = (props: NextFlowProps) => {
  const {
    isReadOnly,
    flowEndInfo: { nextFlow },
  } = props;
  const onTriggerModalObserver = useRef<OnTriggerModalObserver>(new Observable());

  const showExternalTriggersModal = () => {
    onTriggerModalObserver.current.notify(noop);
  };

  return (
    <div className={styles.root} onKeyDown={(e) => e.stopPropagation()}>
      <div className={styles.body}>
        {isEmpty(nextFlow) ? (
          <AddToLinkButton isDisabled={isReadOnly} text="Flow" onClick={showExternalTriggersModal} />
        ) : (
          <NextFlowCard isReadOnly={isReadOnly} onChange={showExternalTriggersModal} {...nextFlow} />
        )}
      </div>
      <NextFlowModal
        flowEndInfo={props.flowEndInfo}
        onFlowEndChange={props.onFlowEndChange}
        onTriggerModalObserver={onTriggerModalObserver.current}
      />
    </div>
  );
};

export default NextFlow;
